import { createSlice } from "@reduxjs/toolkit";
import { API_STATUSES } from "redux/_helpers/statuses";

const fleetReducers = createSlice({
  name: "fleetReducers",
  initialState: {
    getSsidDataStatus: API_STATUSES.REQUEST,
    getSsidData: [],
    setSsidDataStatus: API_STATUSES.REQUEST,
    setSsidData: []
  },

  reducers: {  
    getSsidDataStatus: (state, action) => {
      state.getSsidDataStatus = action.payload;
    },
    getSsidData: (state, action) => {
      state.getSsidData = action.payload;
    },
    setSsidDataStatus: (state, action) => {
      state.setSsidDataStatus = action.payload;
    },
    setSsidData: (state, action) => {
      state.setSsidData = action.payload;
    }
  },
});

export const {
    getSsidDataStatus,
    getSsidData,
    setSsidDataStatus,
    setSsidData
} = fleetReducers.actions;

export default fleetReducers.reducer;
